import ApisService from "apis/ApisService";
import UrlHelper from "helpers/UrlHelper";


const getTemplateData = async (payload: any) => {
    const output = await ApisService.post(UrlHelper.getTemplates, payload)
    if (output) {
        return output
    }
    return {}
}
const getCanvasMedia = async (payload: any) => {
    const output = await ApisService.post(UrlHelper.getCanvasMedia, payload)
    if (output) {
        return output
    }
    return {}
}

const voidChequeSalesApi = async (userId: number) => {
    const data = await ApisService.post(UrlHelper.hasAddedCheque, { mycircle_client_id: Number(userId) }, {
        headers: { Authorization: "" },
    });
    if (data?.data) {
        if (data?.data?.accountSource) {
            localStorage.setItem("accountSource", data?.data?.accountSource)
        }
        if (data?.data?.dsFeatures) {
            if (data?.data?.accountSource === "sales") {
                // localStorage.setItem("dsFeatures", JSON.stringify(staticPermission))
                // setPermissionData(staticPermission)
            } else {
                localStorage.setItem("dsFeatures", JSON.stringify(data?.data?.dsFeatures))
                // setPermissionData(data?.data?.dsFeatures)
            }
        } else {
            if (localStorage.getItem("dsFeatures")) {
                localStorage.removeItem("dsFeatures")
            }
            if (localStorage.getItem("dsFeatures")) {
                localStorage.removeItem("dsFeatures")
            }
        }
        if (data?.data?.isResellerSubclient) {
            // setIsResellerSubclient(true);
        }
        if (data?.status === true) {
            if (data?.data?.isChequeAdded === false && data?.data?.data?.iframeUrl !== "") {
                // setVoidChequeDetails({ status: true, iframeUrl: data?.data?.iframeUrl })
                return { status: true, iframeUrl: data?.data?.iframeUrl }
            } else {
                // setVoidChequeDetails({ status: !data?.data?.isChequeAdded, message: data?.data?.isChequeAdded ? "" : data?.message })
                return { status: !data?.data?.isChequeAdded, message: data?.data?.isChequeAdded ? "" : data?.message }
            }
        } else {
            // setVoidChequeDetails({ status: false, iframeUrl: "", message: "" })
            return { status: false, message: "" }
        }
    } else {
        // setVoidChequeDetails({ status: false, iframeUrl: "", message: "" })
        return { status: false, message: "" }
    }
};

const getPlanStatus = async (clientId: string) => {
    const output = await ApisService.post(UrlHelper.isFreePlan, { clientId }, {
        headers: { Authorization: "" },
    })
    if (output) {
        return output
    }
    return {}
}

const getLocationList = async (clientId: string) => {
    const payload = {
        "client_id": clientId
    }
    const output = await ApisService.post(UrlHelper.getLocationList, payload)
    if (output) {
        return output
    }
    return {}
}

const createSwitchPlateFormToken = async (payload: any) => {
    const output = await ApisService.post(UrlHelper.createSwitchPlateFormToken, payload)
    if (output) {
        return output
    }
    return {}
}

const deleteProjects = async (ids: string[], userId: string) => {
    const data = await ApisService.delete(UrlHelper.deleteUserMedia, { ids, userId }, {
      headers: { Authorization: "" },
    });
    return data
}


const DashboardApis = {
    getTemplateData,
    voidChequeSalesApi,
    getCanvasMedia,
    getLocationList,
    getPlanStatus,
    deleteProjects,
    createSwitchPlateFormToken,
}

export default DashboardApis;